import { render, staticRenderFns } from "./addFeedBack.vue?vue&type=template&id=4df39041"
import script from "./addFeedBack.vue?vue&type=script&lang=js"
export * from "./addFeedBack.vue?vue&type=script&lang=js"
import style0 from "./addFeedBack.vue?vue&type=style&index=0&id=4df39041&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports